










































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavbarDark from '@/components/NavbarDark.vue';
import Compra from '@/components/Compra.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    NavbarDark,
    Compra,
    Footer,
  },
})
export default class CompraTratamiento extends Vue {
  public data() {
    return {
      contents: [
        { text: '• 12 sets de alineadores (tratamiento de 6 meses), separados por semanas'},
        { text: '• Esponjas (chewies) para ajustar tus alineadores'},
        { text: '• Estuche para guardar tus alineadores'},
        { text: '• Removedor de alineadores'},
        { text: '• Kit de blanqueamiento dental Toothly'},
        { text: '• Retenedor para mantener tu sonrisa después del tratamiento'},
      ],
    };
  }

  private quantity = 1;
  private precio = 22000;
  private envio = 0;
  private discount = 0;
  private meses = 0;

  public currentStep() {
    return this.$store.getters.getShoppingCartStep;
  }
  
  public nextStep(): void {
    this.$store.commit(
      'setShoppingCartStep',
      this.$store.getters.getShoppingCartStep + 1,
    );
  }

  public priorStep() {
    this.$store.commit(
      'setShoppingCartStep',
      this.$store.getters.getShoppingCartStep - 1,
    );
  }

  public paypalProductName() {
    return `(${this.quantity}) Kit de Blanqueamiento Toothly`;
  }

  public calculateSubtotal() {
    return this.precio * this.quantity;
  }

  public calculateTotal() {
    return (this.precio * this.quantity) + this.envio - this.discount;
  }
}
